import { render, staticRenderFns } from "./editMagazine.vue?vue&type=template&id=07ddd26e&scoped=true&"
import script from "./editMagazine.vue?vue&type=script&lang=js&"
export * from "./editMagazine.vue?vue&type=script&lang=js&"
import style0 from "./editMagazine.vue?vue&type=style&index=0&id=07ddd26e&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07ddd26e",
  null
  
)

export default component.exports